module.exports = __webpack_public_path__ + "img/child4.a1142c39.png";